module.exports = __webpack_public_path__ + "static/cases-2-cb69732d810b30d334311ab1a39095bd.png";